import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { PayInTypeResource } from './types';

export default (makeCall: MakeCall) => () =>
  makeCall<PayInTypeResource>('GET', `/api/v2/payment/method/pay-in-types`);
